/* Reusable premium empty state — used across all pages */
import { ArrowRight } from "lucide-react";

export default function EmptyState({
  eyebrow,
  title,
  titleItalic,
  body,
  primaryLabel,
  onPrimary,
  secondaryLabel,
  onSecondary,
  icon: Icon,
  testid = "empty-state",
}) {
  return (
    <div
      data-testid={testid}
      className="rounded-3xl text-center py-20 md:py-28 px-6 md:px-10 relative overflow-hidden"
      style={{
        background:
          "radial-gradient(ellipse 60% 50% at 50% 0%, rgba(216,168,87,0.07) 0%, transparent 70%), var(--surface)",
        border: "1px solid var(--ink-22)",
      }}
    >
      {Icon && (
        <div
          className="inline-flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-full mb-7"
          style={{ background: "var(--seal-soft)", color: "var(--seal)" }}
        >
          <Icon size={20} strokeWidth={1.6} />
        </div>
      )}
      {eyebrow && (
        <div className="eyebrow mb-5">
          <span className="seal-dot mr-2 align-middle" /> {eyebrow}
        </div>
      )}
      <h2
        className="font-heading text-3xl sm:text-4xl md:text-5xl leading-[1.05] max-w-xl mx-auto"
        style={{ fontVariationSettings: "'opsz' 96, 'wght' 450" }}
      >
        {title}{" "}
        {titleItalic && <span className="font-display-italic">{titleItalic}</span>}
      </h2>
      {body && (
        <p
          className="mt-6 text-[15px] md:text-[16px] leading-[1.65] max-w-md mx-auto"
          style={{ color: "var(--ink-72)" }}
        >
          {body}
        </p>
      )}
      <div className="mt-10 flex flex-wrap gap-3 justify-center">
        {primaryLabel && (
          <button onClick={onPrimary} className="btn-primary" data-testid={`${testid}-primary`}>
            {primaryLabel} <ArrowRight size={14} />
          </button>
        )}
        {secondaryLabel && (
          <button onClick={onSecondary} className="btn-secondary" data-testid={`${testid}-secondary`}>
            {secondaryLabel}
          </button>
        )}
      </div>
    </div>
  );
}
